export const legalConfig = {
  entityName: process.env.REACT_APP_LEGAL_ENTITY_NAME || 'Service in Mind',
  contactEmail: process.env.REACT_APP_LEGAL_CONTACT_EMAIL || 'serviceinmind@wolverineisland.com',
  address: process.env.REACT_APP_LEGAL_ADDRESS || '',
  lastUpdated: process.env.REACT_APP_LEGAL_LAST_UPDATED || 'June 2025'
};
